import React from 'react'
import {
  SkeletonPostContainer,
  SkeletonHeader,
  SkeletonAvatar,
  SkeletonMeta,
  SkeletonName,
  SkeletonTime,
  SkeletonContent,
  SkeletonLine,
  SkeletonImage,
  SkeletonActions,
  SkeletonAction,
} from '../../NewsFeedStyled'

/**
 * SkeletonPost - Loading placeholder kiểu Facebook
 */
const SkeletonPost = () => {
  return (
    <SkeletonPostContainer>
      {/* Header */}
      <SkeletonHeader>
        <SkeletonAvatar />
        <SkeletonMeta>
          <SkeletonName />
          <SkeletonTime />
        </SkeletonMeta>
      </SkeletonHeader>

      {/* Content */}
      <SkeletonContent>
        <SkeletonLine style={{ width: '100%' }} />
        <SkeletonLine style={{ width: '80%' }} />
        <SkeletonLine style={{ width: '60%' }} />
      </SkeletonContent>

      {/* Image placeholder */}
      <SkeletonImage />

      {/* Actions */}
      <SkeletonActions>
        <SkeletonAction />
        <SkeletonAction />
        <SkeletonAction />
      </SkeletonActions>
    </SkeletonPostContainer>
  )
}

export default SkeletonPost

